<template>
  <div class="assign-promo-code">
    <modal name="assignPromoCode" @before-close="onClose" @before-open="reset" height="auto" :scrollable="true">
      <div style="padding: 20px;">
        <span ><p style="color: red;margin-bottom:20px; font-weight:bold; font-size:16px;">Assign Promo Code</p></span>

        <div class="search-container">
           <label style="display:block; margin-bottom:5px;">Search Promo Code</label>
           <input type="text" v-model="searchQuery" @input="onSearch" placeholder="Type to search..." class="form-control" style="width:100%; height:40px; border:1px solid #ccc; border-radius:4px; padding:8px;">
           
           <div v-if="isLoading" style="margin-top:10px; color:#666;">Searching...</div>

           <ul v-if="results.length > 0" class="promo-results">
              <li v-for="code in results" :key="code.id" @click="selectCode(code)" :class="{ 'selected': selectedCode && selectedCode.id === code.id }">
                  {{ code.code }} 
                  <span v-if="code.description" style="color:#888; font-size:12px; margin-left:10px;">{{ code.description }}</span>
              </li>
           </ul>
           <div v-else-if="!isLoading && searchQuery.length > 0 && results.length === 0" style="margin-top:10px; color:#888;">
              No promo codes found.
           </div>
        </div>

        <div v-if="selectedCode" style="margin-top:20px; padding:10px; background-color:#f0f0f0; border-radius:4px;">
            <strong>Selected:</strong> {{ selectedCode.code }}
        </div>

        <div v-if="error" class="error-msg"><span ><p style="color: red;">{{ errorMessage }}</p></span></div>
        
        <div style="margin-top:20px; text-align:right;">
            <button class="btn btn-secondary" @click="$modal.hide('assignPromoCode')" style="margin-right:10px; background-color:#ccc; border:none; padding:0 20px; border-radius:4px; cursor:pointer; display: inline-flex; align-items: center; justify-content: center; height: 38px; min-width: 100px; font-weight: bold; color: #333;">Cancel</button>
            <button class="btn btn--primary" :disabled="!selectedCode" @click="assign" style="background-color:red; color:white; border:none; padding:0 20px; border-radius:4px; cursor:pointer; display: inline-flex; align-items: center; justify-content: center; height: 38px; min-width: 100px; font-weight: bold;" :style="{ opacity: selectedCode ? 1 : 0.5 }">Assign</button>
        </div>
      </div>
    </modal>  
  </div>
</template>

<script>
  import PromoCodeService from '../../../services/promoCode'
  import _ from 'lodash' // For debounce

  export default {
    name: 'assign-promo-code',
    data: () => ({
        searchQuery: '',
        results: [],
        selectedCode: null,
        isLoading: false,
        error: false,
        errorMessage: ''
    }),
    props: {
        runnerId: ''
    },
    methods: {
        onClose() {
             this.$emit('closed', true)
        },
        onSearch: _.debounce(function() {
            if (this.searchQuery.length < 2) {
                this.results = []
                return
            }
            this.isLoading = true
            this.error = false
            PromoCodeService.getAllPromoCodes(this.searchQuery, 0, 20).then(response => {
                this.results = response.data.content || response.data // Handle Page object or List
                this.isLoading = false
            }).catch(err => {
                console.error(err)
                this.isLoading = false
            })
        }, 300),
        selectCode(code) {
            this.selectedCode = code
        },
        assign() {
            if (!this.selectedCode) return
            
            this.isLoading = true
            this.error = false
            
            PromoCodeService.claimCode(this.selectedCode.code, this.runnerId).then(response => {
                this.isLoading = false
                this.$emit('saved', response.data)
                this.$modal.hide('assignPromoCode')
                this.$dialog.alert("Promo Code assigned successfully!")
            }).catch(error => {
                this.isLoading = false
                this.error = true
                console.error("Assignment failed", error)
                let msg = "Failed to assign promo code."
                if (error.body && error.body.message) {
                    msg = error.body.message
                }
                this.errorMessage = msg
            })
        },
        reset() {
            this.searchQuery = ''
            this.results = []
            this.selectedCode = null
            this.error = false
            this.errorMessage = ''
        }
    },
    watch: {
       // Watch for modal open to reset?
       // The parent usually calls a method or v-if handles it.
       // AddRaceData uses openEditModal method called by parent.
    }
  }
</script>

<style scoped>
  .promo-results {
      list-style: none;
      padding: 0;
      margin-top: 10px;
      border: 1px solid #eee;
      max-height: 200px;
      overflow-y: auto;
  }
  .promo-results li {
      padding: 10px;
      cursor: pointer;
      border-bottom: 1px solid #eee;
  }
  .promo-results li:hover {
      background-color: #f9f9f9;
  }
  .promo-results li.selected {
      background-color: #e0e0e0;
      font-weight: bold;
  }
  .error-msg {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// AssignPromoCode.vue?8fd2c97c